export const RequiredMessage = value => {
  return `${value}을(를) 입력해주세요`;
};

export const AgreeMessage = value => {
  return `${value}에 동의해주세요`;
};

export const SelectMessage = value => {
  return `${value}을(를) 선택해주세요`;
};

export const PASSWORD_VALIDATE_MSG = '비밀번호를 10자 이상 입력해주세요';
export const PASSWORD_UNMATCH_MSG = '비밀번호가 일치하지 않습니다';
export const EMAIL_UNMATCH_MSG = '이메일 형식으로 입력해주세요';
export const UNSIGNED_USER_MSG = '가입되지 않은 사용자입니다';
export const USERNAME_UNMATCH_MSG =
  '입력하신 아이디와 가입하신 아이디가 일치하지 않습니다.';
export const SIGN_UNMATCH_MSG = '아이디 혹은 비밀번호가 일치하지 않습니다.';
export const USERNAME_OVER_MSG = '아이디는 16자리 이하로 입력해주세요.';
export const PASSWORD_SAME_USERNAME_MSG =
  '아이디를 비밀번호에 사용할 수 없습니다.';
export const PERSON_MINIMUM_MSG = '최소 1명 이상은 선택해주세요.';
export const CORRECT_DATE_MSG = '정확한 날짜를 입력해주세요';
export const REQUIRED_ORG_NAME =
  "회사/단체명을 입력해주세요. 개인일 경우, '성함'을 입력해주세요.";
export const CORRECT_PHONE_MSG =
  '정확한 핸드폰 번호를 입력해주세요. ("-" 문자를 넣어주세요)';
export const ERROR_500 = ` 이용에 불편을 드려 죄송합니다. 잠시 후 다시 시도해주세요.
 문제가 반복될 경우 홈페이지 하단의 채널톡
 또는 대표전화(02.322.8601)를 통해 문의 부탁드립니다.`;
export const ERROR_400 = '비정상적인 접근입니다.';
export const REQUIRED_SPACE_OPTION_MSG = '독립공간 사용여부를 선택해주세요';
export const REQUIRED_SPACE_MSG = '필요한 공간을 체크해주세요';
export const REQUIRED_BANK_MSG = '전용계좌를 개설할 은행을 선택해주세요';
export const REQUIRED_PAYMENT_BANK_MSG =
  '결제에 필요한 전용계좌를 발급받아주세요';
export const REQUIRED_PAYMENT_CARD_MSG = '결제할 신용카드를 등록해주세요';

export const COMPLETE_MEMBERSHIP_CARD_MSG = '멤버십 신청이 완료되었습니다.';
export const COMPLETE_MEMBERSHIP_BANK_MSG =
  '멤버십 신청이 완료되었습니다. 발급받으신 계좌로 멤버십 비용을 입금해주세요.';
export const COMPLETE_SPACE_OPTION_MSG =
  '멤버십 신청이 완료되었습니다. 2영업일 이내로 공간옵션에 관한 안내를 드리겠습니다.';
export const MARKETING_DISAGREE_MSG =
  '마케팅수신동의를 미동의로 전환합니다. 로컬스티치의 새로운소식이나 행사정보를 받으실 수 없습니다.';
export const MARKETING_AGREE_MSG = '마케팅 정보 수신동의가 처리되었습니다.';
export const PUSH_DISAGREE_MSG =
  '푸쉬 알림을 끕니다. 로컬스티치로부터 푸쉬 알림을 받지 않습니다.';
export const PUSH_AGREE_MSG = '푸쉬 알림 수신 처리가 완료되었습니다.';
